const specialFlowNames = {
  orgFlow: 'orgFlow',
  netFlow: 'netFlow',
  facebook: 'facebook',
}


export default specialFlowNames
